import '../styles/main.scss';
import feather from 'feather-icons';
import './carousel';
import './copyright';
import './navbar';

document.addEventListener('DOMContentLoaded', () => {
    feather.replace();
});